import React from 'react';
import { Translation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Icon, State } from 'nallian-shared-ui/lib/components';
import { activeStates } from '../helpers/activeStates';

const stateTag = {
  active: (
    <>
      <State success>
        <Icon name="check" title="Active" />
      </State>
      <State success>
        <Translation>{t => t('active')}</Translation>
      </State>
    </>
  ),
  unlisted: (
    <>
      <State isnew>
        <Icon name="ban" title="Unlisted" />
      </State>
      <State isnew>
        <Translation>{t => t('unlisted')}</Translation>
      </State>
    </>
  ),
  inactive: (
    <>
      <State error>
        <Icon name="times" title="Inactive" />
      </State>
      <State error>
        <Translation>{t => t('validated')}</Translation>
      </State>
    </>
  ),
  deleted: (
    <>
      <State>
        <Icon name="trash" title="Deleted" />
      </State>
      <State>
        <Translation>{t => t('deleted')}</Translation>
      </State>
    </>
  ),
  pending: (
    <>
      <State>
        <Icon name="wait" title="Pending" />
      </State>
      <State>
        <Translation>{t => t('pending')}</Translation>
      </State>
    </>
  ),
};

const ActiveState = ({ value }) => {
  const selectedState = activeStates.find(x => x.key === value);

  const stateName = selectedState?.name?.toLowerCase();

  return stateTag[stateName] || '';
};

ActiveState.propTypes = {
  value: PropTypes.number.isRequired,
};

export default ActiveState;
